<template>
  <unsupported-page>
    <template v-slot:title>
      This browser isn’t supported during beta - please try again with one of the supported browsers below.
    </template>
    <template v-slot:body>
      <div class="unsupported-browser__browser">
        <google-chrome class="unsupported-browser__browser-logo"/>
        <a href="https://www.google.com/chrome/">Google Chrome v.94+</a>
      </div>
      <div class="unsupported-browser__browser">
        <opera class="unsupported-browser__browser-logo"/>
        <a href="https://www.opera.com/">Opera v.80+</a>
      </div>
      <div class="unsupported-browser__browser">
        <microsoft-edge class="unsupported-browser__browser-logo"/>
        <a href="https://www.microsoft.com/en-us/edge">Microsoft Edge v.94+</a>
      </div>
    </template>
  </unsupported-page>
</template>
<script setup lang="ts">
import UnsupportedPage from '@/components/unsupported-pages/UnsupportedPage.vue'
import GoogleChrome from '@/assets/GoogleChrome.svg'
import Opera from '@/assets/Opera.svg'
import MicrosoftEdge from '@/assets/MicrosoftEdge.svg'
import GtmHelper from '@/analytics/gtm-helper'
GtmHelper.getInstance().triggerUnsupportedBrowserEvent()
</script>
<style lang="scss">
.unsupported-browser {
  &__browser {
    display: flex;
    flex-direction: column;
    text-align: center;
    align-items: center;

    a {
      margin-top: 15px;
      font-size: 14px;
    }
  }
  &__browser-logo {
    width: 64px;
    margin-left: 38px;
    margin-right: 38px;
  }
}
</style>>
